import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'dmmp-path-link',
  templateUrl: './path-link.component.html'
})
export class PathLinkComponent implements OnInit {

  @Input() path
  @Input() defaultClass
  @Output() page = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
  }

}
